import { createApiClient, ApiError } from '@lunary/api-client'
import { reportOutage } from '@lunary/ui-web/outage'
import { reloadDeck } from '@lunary/ui-web/deck'

let accessToken: string | null = null

export function setAccessToken(token: string | null): void {
  accessToken = token
  reloadDeck()
}

export function getAccessToken(): string | null {
  return accessToken
}

export const API_BASE = '/api/v1'

const RELOAD_KEY = 'lunary.auth-reload-at'

function reloadOnSessionLoss(): void {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_KEY) ?? 0)
    if (Date.now() - last < 60_000) return
    sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
  } catch {
    return
  }
  window.location.reload()
}

export const api = createApiClient({
  baseUrl: API_BASE,
  getAccessToken: () => accessToken,
  refreshAccessToken: async () => {
    const res = await api.post<{ access_token: string }>('/auth/refresh', undefined)
    accessToken = res.access_token
    return accessToken
  },
  onAuthFailure: () => {
    if (!accessToken) return
    accessToken = null
    reloadOnSessionLoss()
  },
  onUnavailable: () => reportOutage(`${API_BASE}/health`),
  onBlocked: () => {
    accessToken = null
    if (window.location.pathname !== '/auth') window.location.assign('/auth?blocked=1')
  },
})

export { ApiError }
